import { render } from "./BaseDocumentation.vue?vue&type=template&id=829083e4"
import script from "./BaseDocumentation.vue?vue&type=script&lang=js"
export * from "./BaseDocumentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__